export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const hasRole = (role) => {
  const user = getCurrentUser();
  return user?.roles?.includes(role);
};

export const hasAnyRole = (roles = []) => {
  const user = getCurrentUser();
  return roles.some(r => user?.roles?.includes(r));
};

export const hasPermission = (permission) => {
  const user = getCurrentUser();

  // SUPER_ADMIN shortcut
//   if (user?.roles?.includes("SUPER_ADMIN")) return true;

  return user?.permissions?.includes(permission);
};

export const hasAnyPermission = (permissions = []) => {
  const user = getCurrentUser();

  if (user?.roles?.includes("SUPER_ADMIN")) return true;

  return permissions.some(p => user?.permissions?.includes(p));
};

export const hasUserType = (type) => {
  const user = getCurrentUser();
  return user?.userType === type;
};
